export const getTruncatedText = (text?: string, suffix?: string, limit = 100) => {
	if (!text) {
		return '';
	}

	if (text.length > limit) {
		return `${text.substr(0, limit - 3)}...${suffix}`
	}
	return text;
}